import { ICartRowItem } from "../../../Cart/types/ICartRowItem";

export interface IProductRowItem extends ICartRowItem {
    IsInCart?: KnockoutObservable<boolean>;
    UoMSelected: KnockoutObservable<string>;
    Quantity: KnockoutObservable<number>;
    UMQtySelected: KnockoutObservable<number>;
}


class ProductRowPayLoad {
    CartOrderID: string;
    ItemID: string;
    QtyOrdered: number;
    UoMPackSize: number;
  
    constructor(data: any) {
        let self = this;

        if (localStorage.getItem("CartSessionKey")) {
            self.CartOrderID = localStorage.getItem("CartSessionKey").toString();
        } else {
            self.CartOrderID = "RequestNewKey";
        }
        
        self.ItemID = data.ItemID;
        self.QtyOrdered = ko.toJS(data.Quantity) || data.QtyOrdered;
        self.UoMPackSize = ko.toJS(data.UMQtySelected) || data.UoMPackSize;
    }
}

export function ProductToAdd(data: any) {
    let payload = new ProductRowPayLoad(data);
    console.debug("ItemRowPayLoad", payload);
    return payload;
}